export default class ArrayUtil
{

	static indexOf(arr,el)
	{
		for (var i=0,n=arr.length; i<n; i++)
		{
			if (arr[i] === el)
			{
			  return i;
			}
		}
	 	return -1;
	}

	static removeByValue(arr,val)
	{
		for(var i=0; i<arr.length; i++)
		{     
			if(arr[i] == val)
			{       
				arr.splice(i, 1);       
				break;     
			}   
		} 
	}

	static swapItems(arr, index1, index2) 
	{
		arr[index1] = arr.splice(index2, 1, arr[index1])[0];
		return arr;
	}
	  
	// 上移
	static upRecord(arr, $index) 
	{
		if($index == 0)
		{
			return;
		}
		ArrayUtil.swapItems(arr, $index, $index - 1);
	}
	  
	// 下移
	static downRecord(arr, $index) 
	{
		if($index == arr.length -1) 
		{
			return;
		}
		ArrayUtil.swapItems(arr, $index, $index + 1);
	}
}


// WEBPACK FOOTER //
// ./src/utils/ArrayUtil.js